import React from 'react';
import {faUser} from '@netx/core-icons';
import {type CellContext, type RowData} from '@tanstack/react-table';
import {
	GenericImageAvatar,
	type IGenericImageAvatarProps,
} from '@netx/core-components/GenericImageAvatar';
import {styled} from '@netx/core-components/Theme';

const GenericImageAvatarCellRoot = styled('div')(({theme}) => ({
	height: '100%',
	width: '100%',
	display: 'flex',
}));

export interface GenericImageAvatarCellProps<
	TData extends RowData,
> extends CellContext<
	TData,
	{
		src: string;
		alt: string;
	}
> {
	GenericImageAvatarProps?: Partial<IGenericImageAvatarProps>;
}

export const GenericImageAvatarCellPrimitive = <TData extends RowData>({
	renderValue,
	GenericImageAvatarProps,
}: GenericImageAvatarCellProps<TData>) => {
	const src = renderValue();
	return (
		<GenericImageAvatarCellRoot>
			<GenericImageAvatar
				{...src}
				icon={faUser}
				{...GenericImageAvatarProps}
				ref={undefined}
			/>
		</GenericImageAvatarCellRoot>
	);
};

export const GenericImageAvatarCell = React.memo(
	GenericImageAvatarCellPrimitive,
) as <TData extends RowData>(
	props: GenericImageAvatarCellProps<TData>,
) => JSX.Element;

export default GenericImageAvatarCell;
